export const selectCities = store => store.citiesStore.cities;
export const selectCityDetails = store => store.citiesStore.cityDetails;
export const selectCityIsLoading = store => store.citiesStore.isLoading;
export const selectCityError = (state) => state.citiesStore.isError;
